import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SideNavBarVisibilityService } from "../../services/side-nav-bar-visibility.service";
import { AdminDashboardService } from "../../services/admin-dashboard.service";
import { NotificationService } from "../../services/notification.service";
import { ZPNotification } from "../../models/zpnotification";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-mail-rules",
    templateUrl: "./mail-rules.component.html",
    styleUrls: ["./mail-rules.component.scss"],
    standalone: false
})
export class MailRulesComponent implements OnInit {
  public list = [];
  public section = "email_config";
  public lineState = [];
  public page: any;
  public totalPages: any;
  public total: any;
  public pageSize = 20;
  public currentPage: number = 1;

  constructor(
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private api: AdminDashboardService,
    private notifications: NotificationService,
    public themeService: ThemeService
  ) {}

  async ngOnInit() {
    this.loadUsers(this.currentPage);
  }

  async loadUsers(page?: number) {
    this.api.getList("email_config", page).then((allUsers) => {
      console.log("allUsers - ", allUsers);
      this.page = allUsers.page;
      this.totalPages = allUsers.pages;
      this.total = allUsers.total;
      this.list = allUsers.items;
      console.log("list: ", this.list);
    });
  }

  async saveItem(index) {
    let item = this.list[index];
    let result = await this.api.putItem(this.section, item);
    if (result && result.success) {
      this.notifications.changeMessage(new ZPNotification("Item Saved"));
      this.toggleSection(index);
      this.loadUsers();
    } else {
      this.notifications.changeMessage(new ZPNotification("Save failed"));
    }
  }

  async deleteItem(index) {
    let item = this.list[index];
    let success = await this.api.deleteItem(this.section, item);
    if (success) {
      this.notifications.changeMessage(
        new ZPNotification("Item has been deleted")
      );
      this.loadUsers();
    } else {
      this.notifications.changeMessage(
        new ZPNotification("Item has been deleted")
      );
    }
  }

  toggleSection(index) {
    if (this.lineState[index]) {
      this.lineState[index] = false;
    } else {
      this.lineState[index] = true;
    }
  }

  addNew() {
    let current = this.list.length;
    this.list.push({
      name: "New Template",
      purpose: "",
      subject: "",
      rule: "",
      body: "",
    });
    this.lineState[current] = true;
  }
}
